module.exports = __webpack_public_path__ + "static/dominikawork4-ab46530b98b802864c32f3abf6c56c68.jpg";